<template>
  <main class="publish-main">
    <b-container
      class="publish-container mr-3 d-flex flex-column justify-content-between"
    >
      <section class="px-3 py-2 overflow-auto">
        <div class="publish-head">Platform</div>
        <div class="publish-subhead mt-1">
          Candidates will be able to apply for jobs on these platform
        </div>
        <div class="common-white-card mt-3 w-100">
          <b-card class="py-1">
            <div class="d-flex align-items-center">
              <img src="@/assets/publishJobs/vccl.svg" alt="" />
              <img src="../../../assets/img/line.svg" alt="" class="mx-3" />
              <div class="publish-head">Job Platform</div>
            </div>
            <div class="ct-table-switch">
              <b-form-checkbox
                v-model="jobData.openToPublic"
                switch
              ></b-form-checkbox>
            </div>
          </b-card>
        </div>
        <div
          v-if="thirdPartyData.carrerPage"
          class="common-white-card mt-3 w-100"
        >
          <b-card class="py-1">
            <div class="d-flex align-items-center">
              <img src="@/assets/publishJobs/vccl.svg" alt="" />
              <img src="../../../assets/img/line.svg" alt="" class="mx-3" />
              <div class="publish-head">Careers Page</div>
            </div>
            <div class="ct-table-switch">
              <b-form-checkbox
                v-model="jobData.carrerPage"
                switch
              ></b-form-checkbox>
            </div>
          </b-card>
        </div>
        <!-- <div class="common-white-card mt-3 w-100">
          <b-card class="py-1">
            <div class="d-flex align-items-center">
              <img src="../../../assets/img/publish-linkedIn.svg" alt="" />
              <img src="../../../assets/img/line.svg" alt="" class="mx-3" />
              <div class="publish-head">LinkedIn</div>
            </div>
            <div class="ct-table-switch">
              <b-form-checkbox
                v-model="jobData.linkedIn"
                switch
              ></b-form-checkbox>
            </div>
          </b-card>
        </div>
        <div class="common-white-card mt-3 w-100">
          <b-card class="py-1">
            <div class="d-flex align-items-center">
              <img src="../../../assets/img/publish-naukri.svg" alt="" />
              <img src="../../../assets/img/line.svg" alt="" class="mx-3" />
              <div class="publish-head">Naukri</div>
            </div>
            <div class="ct-table-switch">
              <b-form-checkbox v-model="jobData.naukri" switch></b-form-checkbox>
            </div>
          </b-card>
        </div> -->
      </section>
      <section class="publish-footer d-flex align-items-center py-2 px-3">
        <img src="../../../assets/img/publish-i.svg" alt="" />
        <div class="ml-2">
          Platforms are based on your successful integrations with
          <span style="color: #20639b"> “Third Parties Integrations” </span>
        </div>
      </section>
    </b-container>
    <b-container class="p-0 h-100">
      <!-- bind this conditionally according to scenario  style="height: 68%" -->
      <b-container
        :style="
          !jobData.automatic && assessIntProcess
            ? 'height: 59%'
            : !jobData.automatic
            ? 'height: 68%'
            : ''
        "
        class="publish-inner-container overflow-auto"
        ><section class="px-3 pt-2 pb-4">
          <div class="publish-head">Notifications</div>
          <div class="publish-subhead mt-1">
            Candidates will be able to get notified through these platforms
          </div>
          <div class="publish-blue-card mt-3 w-100">
            <b-card>
              <div
                class="w-100 d-flex align-items-center justify-content-between"
              >
                <!-- w-33 -->
                <div
                  class="d-flex align-items-center justify-content-between w-80"
                >
                  <div class="d-flex align-items-center">
                    <img src="../../../assets/img/publish-mail.svg" alt="" />
                    <div class="publish-head pl-3">Mail</div>
                  </div>
                  <!-- <div class="ct-table-switch">
                    <b-form-checkbox
                      disabled
                      v-model="jobData.mailNotification"
                      switch
                    ></b-form-checkbox>
                  </div> -->
                </div>
                <div class="ct-table-switch">
                  <b-form-checkbox
                    disabled
                    v-model="jobData.mailNotification"
                    switch
                  ></b-form-checkbox>
                </div>
                <!-- <img src="../../../assets/img/line.svg" alt="" class="mx-3" /> -->
              </div>
              <!-- <div
                class="w-33 d-flex align-items-center justify-content-between"
              >
                <div
                  class="d-flex align-items-center justify-content-between w-80"
                >
                  <div class="d-flex align-items-center">
                    <img src="../../../assets/img/publish-message.svg" alt="" />
                    <div class="publish-head pl-3">Message</div>
                  </div>
                  <div class="ct-table-switch">
                    <b-form-checkbox
                      v-model="jobData.textNotification"
                      switch
                    ></b-form-checkbox>
                  </div>
                </div>
                <img src="../../../assets/img/line.svg" alt="" class="mr-3" />
              </div>
              <div class="w-33 d-flex align-items-center">
                <div
                  class="d-flex align-items-center justify-content-between w-80"
                >
                  <div class="d-flex align-items-center">
                    <img
                      src="../../../assets/img/publish-whatsapp.svg"
                      alt=""
                    />
                    <div class="publish-head pl-3">Whatsapp</div>
                  </div>
                  <div class="ct-table-switch">
                    <b-form-checkbox
                      v-model="jobData.whatsAppNotification"
                      switch
                    ></b-form-checkbox>
                  </div>
                </div>
              </div> -->
            </b-card>
          </div>
        </section>
      </b-container>
      <!-- bind this height also conditionally when required    style="height: 29%" -->
      <b-container
        ref="scrollContainer"
        class="publish-inner-container mt-3 overflow-auto"
        :style="
          !jobData.automatic && assessIntProcess
            ? 'height: 37%'
            : !jobData.automatic
            ? 'height: 29%'
            : 'height: calc(100% - 160px)'
        "
      >
        <section class="px-3 py-2 h-100">
          <section
            class="w-100 d-flex align-items-center justify-content-between"
          >
            <div class="publish-head d-flex">
              Applicants qualification threshold %
              <div
                class="position-relative"
                @mouseenter="showTooltipPlace = 'first'"
                @mouseleave="
                  (showTooltipPlace = null),
                    !jobData.automatic ? scrollToBottom() : ''
                "
              >
                <img
                  src="../../../assets/img/info-icon-publish.svg"
                  class="ml-2 pb-1"
                  alt=""
                />
                <div
                  v-if="showTooltipPlace == 'first'"
                  class="cs-tooltip-place"
                >
                  <div class="mt-1">
                    Candidates qualifies if score exceeds percentage
                  </div>
                </div>
              </div>
            </div>
            <div class="w-30 d-flex justify-content-end">
              <div
                class="
                  newmodalinputbox
                  add-input-h-w
                  ml-2
                  d-flex
                  align-items-center
                  position-relative
                "
              >
                <b-form-input
                  :class="{
                    error: validationObj.platformData.threshold.$error,
                  }"
                  v-model.number="validationObj.platformData.threshold.$model"
                  @keydown="restrictInput($event, jobData.threshold)"
                  class="px-2 padding-10px w-100 h-100"
                >
                </b-form-input>
                <span class="newmodal-input-label ml-2">%</span>
                <div
                  class="errortxt position-absolute thresh-error"
                  v-if="validationObj.platformData.threshold.$error"
                >
                  Should be greater than 25
                </div>
              </div>
            </div>
          </section>
          <!-- <section class="w-100 d-flex flex-column">
            <div class="publish-head">Applicants qualification threshold</div>
            <div class="d-flex justify-content-between w-100">
              <div class="publish-subhead mt-1 w-70">
                Candidates qualifies if score exceeds percentage
              </div>
              <div class="w-30 d-flex justify-content-end">
                <div
                  class="
                    newmodalinputbox
                    add-input-h-w
                    ml-2
                    d-flex
                    align-items-center
                    position-relative
                  "
                >
                  <b-form-input
                    :class="{
                      error: validationObj.platformData.threshold.$error,
                    }"
                    v-model.number="validationObj.platformData.threshold.$model"
                    @keydown="restrictInput"
                    class="px-2 padding-10px w-100 h-100"
                  >
                  </b-form-input>
                  <span class="newmodal-input-label ml-2">%</span>
                  <div
                    class="errortxt position-absolute thresh-error"
                    v-if="validationObj.platformData.threshold.$error"
                  >
                    Should be greater than 25
                  </div>
                </div>
              </div>
            </div>
          </section> -->
          <section
            v-if="assessIntProcess"
            class="mt-3 w-100 d-flex align-items-center justify-content-between"
          >
            <div class="publish-head d-flex">
              Minimum Assessment Cheating %
              <div
                class="position-relative"
                @mouseenter="showTooltipPlace = 'sec'"
                @mouseleave="
                  (showTooltipPlace = null),
                    !jobData.automatic ? scrollToBottom() : ''
                "
              >
                <img
                  src="../../../assets/img/info-icon-publish.svg"
                  class="ml-2 pb-1"
                  alt=""
                />
                <div v-if="showTooltipPlace == 'sec'" class="cs-tooltip-place">
                  <div class="mt-1">Minimum Assessment Cheating</div>
                </div>
              </div>
            </div>
            <div class="w-30 d-flex justify-content-end">
              <div
                class="
                  newmodalinputbox
                  add-input-h-w
                  ml-2
                  d-flex
                  align-items-center
                  position-relative
                "
              >
                <b-form-input
                  :class="{
                    error:
                      validationObj.platformData.maxCheatingPercentage.$error,
                  }"
                  v-model.number="
                    validationObj.platformData.maxCheatingPercentage.$model
                  "
                  @keydown="
                    restrictInput($event, jobData.maxCheatingPercentage)
                  "
                  class="px-2 padding-10px w-100 h-100"
                >
                </b-form-input>
                <span class="newmodal-input-label ml-2">%</span>
                <div
                  class="errortxt position-absolute thresh-error"
                  v-if="validationObj.platformData.maxCheatingPercentage.$error"
                >
                  Should be greater than or equal to 0
                </div>
              </div>
            </div>
          </section>
          <section
            class="mt-3 w-100 d-flex align-items-center justify-content-between"
          >
            <div class="publish-head d-flex">
              Do you want this recruitment process to be automated?
              <div
                class="position-relative"
                @mouseenter="showTooltipPlace = 'third'"
                @mouseleave="
                  (showTooltipPlace = null),
                    !jobData.automatic ? scrollToBottom() : ''
                "
              >
                <img
                  src="../../../assets/img/info-icon-publish.svg"
                  class="ml-2 pb-1"
                  alt=""
                />
                <div
                  v-if="showTooltipPlace == 'third'"
                  class="cs-tooltip-place"
                >
                  <div class="mt-1">
                    Turn on to automate assessments and<br />
                    schedule interviews with Hire3x panelists,<br />
                    based on available credits.
                  </div>
                </div>
              </div>
            </div>
            <div class="common-single-checkbox" style="margin-right: -9px">
              <b-form-checkbox v-model="jobData.automatic"> </b-form-checkbox>
            </div>
          </section>
          <template v-if="jobData.automatic">
            <section
              class="
                mt-2
                w-100
                d-flex
                align-items-center
                justify-content-between
              "
            >
              <div class="publish-head position-relative d-flex">
                Manual Review of applications Required?
                <div
                  @mouseenter="showTooltipPlace = 'fourth'"
                  @mouseleave="showTooltipPlace = null"
                  class="position-relative"
                >
                  <img
                    src="../../../assets/img/info-icon-publish.svg"
                    class="ml-2 pb-1"
                    alt=""
                  />
                  <div
                    v-if="showTooltipPlace == 'fourth'"
                    class="cs-tooltip-place"
                  >
                    <div class="mt-1">
                      Enable to manually move<br />
                      Hire3xAI-qualified candidates to<br />
                      Round 1 of the interview process.
                    </div>
                  </div>
                </div>
              </div>
              <div class="ct-table-switch" style="margin-right: -16px">
                <b-form-checkbox v-model="jobData.manualReview" switch>
                </b-form-checkbox>
              </div>
            </section>
            <section
              class="
                mt-3
                w-100
                d-flex
                align-items-center
                justify-content-between
              "
            >
              <div class="w-60">
                <div class="publish-head">
                  Limit Credits
                  <img
                    v-b-tooltip.hover="'Refresh Credits'"
                    @click="$emit('get-credits')"
                    class="ml-2 pointer"
                    height="20"
                    width="20"
                    src="@/assets/new-kanban-icons/refreshBlog.svg"
                    alt
                  />
                </div>
                <div class="publish-subhead mt-1">
                  Available Credits:
                  <span class="publish-head">
                    <!-- ₹{{ isCreate ? remainingCredits.toLocaleString() : totalCredits.toLocaleString() }} -->
                    ₹{{
                      totalCredits
                        ? totalCredits.toLocaleString()
                        : totalCredits
                    }}
                  </span>
                  ({{ maxInterviews }} Interviews)
                </div>
              </div>
              <div class="w-40 text-right">
                <div class="publish-subhead d-flex justify-content-end gap-5px">
                  <span style="margin-top: 3px"> Remaining Credits: </span>
                  <div class="publish-head">
                    ₹{{
                      remainingCredits
                        ? remainingCredits.toLocaleString()
                        : remainingCredits
                    }}
                  </div>
                </div>
                <div
                  v-if="
                    remainingCredits == 0 && roles.includes('HIRE3X_WALLET')
                  "
                  class="publish-subhead mt-1"
                >
                  Need more Credits?
                  <span class="add-new-font pointer" @click="goToCredits()">
                    Add Now
                  </span>
                </div>
              </div>
            </section>
            <section class="mt-3 w-100 d-flex align-items-center">
              <div class="publish-head">
                No of Interview: <span class="asterik">*</span>
              </div>

              <div class="newmodalinputbox ml-3 w-20 position-relative">
                <b-form-input
                  @keypress="NumbersOnly"
                  :class="{
                    error:
                      validationObj.platformData.noOfInterviews.$error ||
                      interviewExceeded,
                  }"
                  v-model="validationObj.platformData.noOfInterviews.$model"
                  type="number"
                  min="1"
                  class="px-2 padding-10px w-100 h-100"
                >
                </b-form-input>
                <div
                  class="newInt-required-validation-font text-nowrap"
                  v-if="interviewExceeded"
                >
                  Insufficient credits
                </div>
                <div
                  class="newInt-required-validation-font text-nowrap"
                  v-else-if="validationObj.platformData.noOfInterviews.$error"
                >
                  {{
                    validationObj.platformData.noOfInterviews.required &&
                    !validationObj.platformData.noOfInterviews.minValue
                      ? "Should be greater than 0"
                      : validationObj.platformData.noOfInterviews.required &&
                        !validationObj.platformData.noOfInterviews
                          .lessThanTakenCount
                      ? minIntrw == 1
                        ? `${minIntrw} interview is already scheduled`
                        : `${minIntrw} interviews are already scheduled`
                      : "Required"
                  }}
                </div>
              </div>
            </section>

            <section
              class="
                mt-3
                mb-2
                w-100
                d-flex
                align-items-center
                justify-content-between
              "
            >
              <div class="w-60">
                <div class="publish-head">Select Platform</div>
                <div class="publish-subhead mt-1">
                  Select a meeting platform to conduct the interview
                </div>
              </div>
              <div class="w-40 mt-1 text-right">
                <div
                  @click="showMeetingoptions = !showMeetingoptions"
                  ref="srcdropdown"
                  v-closable="{
                    exclude: ['src', 'srcdropdown'],
                    handler: 'hideMeeting',
                  }"
                  class="
                    pointer
                    schedint-moi
                    d-flex
                    align-items-center
                    justify-content-between
                    position-relative
                  "
                >
                  <div
                    class="input-empty-placeholder"
                    v-if="!jobData.meetingPlatform"
                  >
                    Select
                  </div>
                  <div v-else>
                    <img
                      v-if="selectedMeetingIcon()"
                      :src="selectedMeetingIcon()"
                      class="mr-1"
                      alt=""
                    />
                    {{ selectedMeetingOption }}
                  </div>
                  <div>
                    <img
                      v-if="!showMeetingoptions"
                      src="@/assets/cvsearch/cv-downarrow.svg"
                      alt=""
                    />
                    <img
                      v-else
                      class="pointer"
                      src="@/assets/cvsearch/cv-uparrow.svg"
                      alt=""
                    />
                  </div>
                  <div
                    ref="src"
                    v-if="showMeetingoptions"
                    style="top: -63px; z-index: 2"
                    class="w-100 kanban-more-option-card"
                  >
                    <!-- -63px -->
                    <!-- -70px -->
                    <ul class="platform-dropdown m-0 p-0 w-100">
                      <li
                        v-for="option in meetingOptions"
                        :key="option.text"
                        :style="
                          jobData.meetingPlatform == option.value &&
                          'background-color: #c8d9e5 !important'
                        "
                        @click="assignLink(option.value)"
                        class="kanban-more-option-card-input"
                      >
                        <img
                          v-if="option.icon"
                          :src="option.icon"
                          class="mr-1"
                          alt=""
                        />
                        {{ option.text }}
                      </li>
                    </ul>
                  </div>
                </div>
                <!-- import your select component here -->
              </div>
            </section>
          </template>
        </section>
      </b-container>
    </b-container>
  </main>
</template>

<script>
import { NumbersOnly } from "../../../controllers/Candidate/helpers";
import { mapGetters } from "vuex";
export default {
  props: {
    jobData: Object,
    isCreate: Boolean,
    validationObj: Object,
    totalCredits: Number,
    costPerInterview: Number,
    interviewExceeded: Boolean,
    minIntrw: Number,
    assessIntProcess: Boolean,
    roles: Array,
  },
  data() {
    return {
      showTooltipPlace: false,
      showMeetingoptions: false,
    };
  },
  computed: {
    ...mapGetters("userVUEX", {
      thirdPartyData: "getThirdPartyData",
    }),
    selectedMeetingOption() {
      let dataVal = this.meetingOptions.find(
        (obj) => obj.value == this.jobData.meetingPlatform
      );
      return dataVal.text;
    },
    remainingCredits() {
      if (this.jobData.noOfInterviews <= this.minIntrw)
        return this.totalCredits;
      else {
        let interviews = this.jobData.noOfInterviews
          ? this.jobData.noOfInterviews - this.minIntrw
          : 0;
        let remainingCredit =
          this.totalCredits - this.costPerInterview * interviews;
        return remainingCredit < 0 ? 0 : remainingCredit;
      }
    },
    maxInterviews() {
      // if(this.isCreate) return parseInt(this.remainingCredits / 1000);
      return parseInt(this.totalCredits / this.costPerInterview);
    },
    meetingOptions() {
      let meetingOpts = [];
      meetingOpts.push({
        icon: require("@/assets/publishJobs/vccl.svg"),
        text: "Hire3x - VCCL",
        value: "vccl",
      });
      if (this.checkAccess("msteams")) {
        meetingOpts.push({
          icon: require("@/assets/img/newkanban/Teams.svg"),
          text: "Microsoft Teams",
          value: "teams",
        });
      }
      // if (this.checkAccess('gmeet')) {
      //   meetingOpts.push({
      //     icon: require("@/assets/img/newkanban/gmeet.svg"),
      //     text: "Google Meet",
      //  value: 'gmeet'
      //   });
      // }
      return meetingOpts;
    },
  },
  // watch:{
  //   jobData(val){
  //     console.log('jobdata', val)
  //   }
  // },
  methods: {
    checkAccess(type) {
      let val = this.thirdPartyData.data.find(
        (obj) => obj.thirdPartyID == type
      );
      if (!val) {
        return false;
      }
      return val.enabled;
    },
    scrollToBottom() {
      const container = this.$refs.scrollContainer;
      container.scrollTo({
        top: container.scrollHeight,
        behavior: "smooth",
      });
    },
    goToCredits() {
      // window.open("https://utility.simplifycv.com/login");
      window.open("https://utility.hire3x.com");
    },
    selectedMeetingIcon() {
      let dataVal = this.meetingOptions.filter(
        (obj) => obj.value == this.jobData.meetingPlatform
      );
      return dataVal[0].icon;
    },
    assignLink(type) {
      this.jobData.meetingPlatform = type;
      this.showMeetingoptions = false;
    },
    hideMeeting() {
      this.showMeetingoptions = false;
    },
    NumbersOnly(evt) {
      NumbersOnly(evt, true);
    },
    restrictInput(event, value) {
      const invalidKeys = [
        "ArrowUp",
        "ArrowDown",
        "ArrowLeft",
        "ArrowRight",
        "Backspace",
        "Tab",
        "Delete",
      ];

      // Check if the key is not a number and not in the invalid keys
      if (!/[0-9]/.test(event.key) && !invalidKeys.includes(event.key)) {
        event.preventDefault(); // Prevent invalid input
      }

      // If the key is a number, check if it would exceed 100
      if (/[0-9]/.test(event.key)) {
        const currentValue = value ? value.toString() : "";
        const newValue = currentValue + event.key;

        // If adding a key would make the number greater than 100, prevent it
        if (Number(newValue) > 100) {
          event.preventDefault();
        }
      }
    },
  },
};
</script>

<style scoped>
.publish-main {
  padding: 20px 40px;
  display: flex;
  height: 100%;
}

.publish-container {
  max-width: 50%;
  height: 100%;
  background: #ffffff;
  box-shadow: 0px 1px 8px 0px #0000002b;
  border-radius: 8px;
  padding: 0px;
}

.publish-head {
  font-family: "Lato", sans-serif;

  font-weight: 600;
  font-size: 16px;
  color: #000000;
}

.publish-subhead {
  font-family: "Montserrat", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #72738e;
}

.common-white-card .card-body {
  justify-content: space-between;
  width: 100%;
}

.publish-footer {
  background: #f6f9fb;
  border-radius: 8px;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 13px;
  color: #344054;
}

.publish-inner-container {
  max-width: 100%;
  background: #ffffff;
  box-shadow: 0px 1px 8px 0px #0000002b;
  border-radius: 8px;
  padding: 0px;
}

.add-input-h-w .form-control {
  width: 41px !important;
  height: 30px !important;
}

.publish-blue-card .card {
  background: #fcfdff;
  border: 1px solid rgba(140, 140, 140, 0.15);
  box-shadow: 0px 4px 4px 1px rgba(111, 111, 111, 0.05);
  border-radius: 8px;
  width: 100%;
}

.publish-blue-card .card-body {
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
  width: 100%;
  padding: var(--size-10) var(--size-15);
}

.add-new-font {
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  text-decoration-line: underline;

  color: #20639b;
}
.platform-dropdown li {
  list-style-type: none;
  text-align: justify;
}
.thresh-error {
  bottom: -1rem;
  left: -70px;
  white-space: nowrap;
}
</style>
